<!--
배송등록(수동) 에서 사용되는 필드셋 패널
-->
<template>
    <div :class="cssClass" class="uk-card uk-card-small uk-card-default simple-card">
        <div class="uk-card-header uk-flex uk-flex-between uk-flex-bottom">
            <div class="title">{{ title }}</div>
            <slot name="title-desc"></slot>
        </div>
        <div class="uk-card-body" >
            <slot>EMPTY</slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 제목
             */
            title: {
                type: String,
                default: '',
            },

            /**
             * 스타일
             * - slim
             */
            theme: {
                type: String,
                default: null,
            },
        },

        computed: {
            /**
             * 전체 컴포넌트에 정의될 css 클래스명
             */
            cssClass: function () {
                let classes =  {
                };
                if (this.theme) {
                    classes[this.theme] = true;
                }
                return classes;
            },

        }


    }
</script>

<style lang="scss" scoped>
.uk-card {
    border-radius: 0.5rem;
    border: 1px solid #ddd !important;

    .uk-card-header {
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
        background-color: #fafafa;
        color: #344766;

        .title {
            font-weight: bold;
        }
    }

    // 슬림 스타일
    &.slim {

        .uk-card-header {
            padding: 0.5rem 1.5rem;

            .title {
                color: #999;
                font-weight: normal;
            }
        }

        .uk-card-body {
            padding: 0.5rem;
        }
    }

}

</style>